import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/googlePlay.svg';

export const IconGooglePlay = createIconComponent(Icon);
